import React from "react";
//PAGES
import Home from "./pages/Home/Home";
//ESTILOS
import "./index.css";

export default function App() {
  return (<Home />);
};
